import { APPLICATION_INSIGHTS_APP_NAME } from "@src/constants";
import initializeAppInsights from "@openup/shared/helpers/appInsights/AppInsights";
import { env } from "@src/env";

const ai = initializeAppInsights(
  env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
  APPLICATION_INSIGHTS_APP_NAME,
  env.REACT_APP_VERSION,
);
const setAuthenticatedUserContext = (userId: string) => {
  ai.appInsights.setAuthenticatedUserContext(userId, "", true);
};
const clearAuthenticatedUserContext = () => {
  ai.appInsights.clearAuthenticatedUserContext();
};

export const { appInsights, reactPlugin } = ai;
export { setAuthenticatedUserContext, clearAuthenticatedUserContext };
